<template>
  <div class="slds-grid slds-grid_frame slds-wrap slds-grid_vertical slds-grid_vertical-stretch slds-p-around_medium" style="padding:0.4rem;">
    <div class="slds-col slds-grid slds-grid_vertical slds-p-top_none slds-align_absolute-center" v-if="local_sessiondetail != null">
      <div class="slds-text-heading_medium slds-m-bottom_medium" v-html="local_sessiondetail.redirectMessage"></div>
      <h1 v-if="isCountdown == 'true'" class="slds-text-heading_medium slds-m-bottom_medium">{{countdown}}</h1>
      <div class="slds-text-heading_small"><a v-on:click="clearTimer" :href="local_sessiondetail.redirectLink" :target="target">Click here</a> {{ redirectAutomaticMessage }}</div>
    </div>
  </div>
</template>

<script>
import { GET_SESSION_DETAILS } from './store/store.js'
import { mapGetters } from "vuex";

export default {
  name: 'app',
  data() {
    return{
      local_sessiondetail : null,
      countdown : 5,
      target: '_blank',
      interval : null,
      redirectAutomaticMessage : "if you are not redirected automatically",
      isCountdown : true,
    }
  },
 computed:{
    ...mapGetters(["sessionDetails"])
  },
  methods:{
    clearTimer(){
      this.countdown = 0;
      clearInterval(this.interval);
    }
  },
  mounted() {
    this.$store.dispatch(GET_SESSION_DETAILS).then(() => {
      this.local_sessiondetail = this.sessionDetails;
      this.isCountdown = this.local_sessiondetail.isCountdown;
      this.redirectAutomaticMessage = this.local_sessiondetail.redirectAutomaticMessage;
      if(this.isCountdown == 'true'){
        this.target = this.local_sessiondetail.isRedirectToNewTab.toLowerCase() == 'true' ? '_blank' : '_self';
        this.interval = setInterval(() => { 
            if(this.countdown > 0){
              this.countdown --;
            }else{
              clearInterval(this.interval);
              window.open(this.local_sessiondetail.redirectLink,this.target);
            }
        }, 1000);
      }
    })
  },
}
</script>
